// extracted by mini-css-extract-plugin
export default {"mainTabButtons":"style_mainTabButtons__I9Qt1","mainTabButtons1":"style_mainTabButtons1__8Szda","title":"style_title__t8Cnr","wrapper":"style_wrapper__ewG0h"};